import { Alert, AlertProps } from 'antd';
import classNames from 'classnames';
import { FC } from 'react';
import { alertIcon, errorIconV2, infoIconV2, successIcon, closeGreyLightIcon } from './assets';
import type { IProps } from './types';
import './style.scss';

const AlertBanner: FC<IProps> = ({
  alertType = 'success',
  closable = false,
  onClose = undefined,
  description = '',
  title = '',
  ariaLabel = '',
  className = '',
}) => {
  /**
   * Chooses the leading icon image of an alert banner from its alert type. Maps success, info, warning and error to their icon images and returns null for any other type.
   *
   * @returns An image element for the alert type, or null.
   */
  const renderIcon = (): AlertProps['icon'] => {
    switch (alertType) {
      case 'success':
        return <img src={successIcon} alt="icon alert" />;
      case 'info':
        return <img src={infoIconV2} alt="icon alert" />;
      case 'warning':
        return <img src={alertIcon} alt="icon alert" />;
      case 'error':
        return <img src={errorIconV2} alt="icon alert" />;
      default:
        return null;
    }
  };

  return (
    <Alert
      className={classNames('custom-alert-banner', className)}
      type={alertType}
      closable={closable}
      onClose={onClose}
      message={title}
      description={description}
      aria-label={
        ariaLabel ||
        (typeof title === 'string' && title
          ? title
          : typeof description === 'string'
            ? description
            : undefined)
      }
      showIcon
      icon={renderIcon()}
      closeIcon={<img src={closeGreyLightIcon} alt="close icon" />}
    />
  );
};

export default AlertBanner;
